import { useBreadcrumbs } from 'global/cnr/contexts/useHelpers/useBreadcrumbs';
import React, { createContext, useEffect, useMemo, useReducer, useState } from 'react'
import Wrapper, { wrapperTypes } from './Wrapper';
import ItemMenuSquares from './ItemMenuSquares';
import { Icon } from 'semantic-ui-react';
import { groupSquaresHandlers, groupSquaresInitialState, groupSquaresReducer } from 'global/cnr/reducers/GroupSquaresReducer';

export const GroupSquaresContext = createContext()

export const GroupSquares = ({
  caption,
  updating,
  menuItems,
  fnCurrentGroup,
  fnTrigger,
  fnAlt,
  fnIcon,
  iconItem,
  noHeader,
  imsType,
  noItemIcon
}) => {


  const [groupSquares_state, dispatch] = useReducer(groupSquaresReducer, groupSquaresInitialState(menuItems));
  const groupSquares_handlers = groupSquaresHandlers(dispatch);
  const { handleSet_allGroups, handleGo_backTo, handleGo_back } = groupSquares_handlers ?? {}

  const { allGroups } = groupSquares_state ?? {}

  useEffect(() => {
    const _allGroups = []
    _allGroups.push({
      key: menuItems?.options || menuItems?.items,
      value: '',
      caption: caption || _.startCase('sportsOptions'),
      menuItems: menuItems
    })
    handleSet_allGroups(_allGroups)
  }, []);

  const backLinks = useMemo(() => {
    const bl = _.map(
      allGroups.slice(0, -1),
      (group) => (
        {
          key: group.key || 0,
          caption: group.caption
        }
      )
    );
    return bl
  }, [allGroups])

  const currentGroup = allGroups?.[allGroups.length - 1]

  // const goBackTo = (index) => {
  //   const _allGroups = _.clone(allGroups)
  //   if (index < 0 || index >= _allGroups.length) return;
  //   if (_allGroups.length <= 1) return;
  //   const all_groupz = _allGroups.slice(0, index + 1)
  //   setAllGroups(all_groupz)
  // }

  const bcrb = useBreadcrumbs({ items: backLinks, onClick: handleGo_backTo })

  // const goBack = () => {
  //   const _allGroups = _.clone(allGroups)
  //   if (_allGroups.length <= 1) { return; }
  //   const all_groups = _allGroups.slice(0, -1)
  //   setAllGroups(all_groups)
  // }

  const header_top = () => {
    const currentGroup = allGroups?.[allGroups.length - 1]
    const { caption, key } = currentGroup ?? {}
    const _caption = caption || _.startCase(key)
    return <div className='swr-header'>
      {bcrb}
      <div className='swr-header-cap'>
        {allGroups.length > 1 && <Icon color={'blue'} name='arrow left' onClick={() => handleGo_back()}></Icon>}
        {_caption}</div>
    </div>
  }

  const addToGroup = (group) => {
    const _allGroups = _.clone(allGroups)
    _allGroups.push(group)
    handleSet_allGroups(_allGroups)
  }

  const onClick_optionType = (value) => {
    fnTrigger && fnTrigger(value)
    return addToGroup({
      key: value,
      value: value,
      caption: _.startCase(value),
    })
  }

  const content_currentGroup = (cg) => {
    if (allGroups) {
      const _currentGroup = cg || currentGroup
      const { key, menuItems, value } = _currentGroup ?? {}
      switch (key) {
        case menuItems?.options:
          const items = _.omit(menuItems, [menuItems?.options])
          return <ItemMenuSquares
            menuItems={items}
            onClick={onClick_optionType}
            icon={'arrow right'}
            iconItem={iconItem || 'arrow right'}
            fn_icon={fnIcon}
            fn_altContent={fnAlt}
            fullRow={true}
            imsType={imsType}
            noItemIcon={noItemIcon}
          />
        default:
          return fnCurrentGroup(currentGroup)
      }
    }
  }

  const wrapper = () => <Wrapper
    header={!noHeader && header_top()}
    content={content_currentGroup()}
    wrapperType={wrapperTypes.padded}
    updating={updating}
  ></Wrapper>

  return wrapper()
}
